import queryString from "query-string";
import {defaultVariabls} from "./index";

export const howToSale = ["روش فروش ۵","روش فروش ۴","روش فروش ۳","روش فروش ۲","روش فروش ۱"];

export function toEnglishDigits(str) {

    let  e = '۰'.charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
    });
    return str;
}

export function price(x) {
    if(!!x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    }else {
        return x
    }
}

export function truncate(str, n){
    if(!!str){
        return (str.length > n) ? str.substr(0, n-1) + '...' : str;
    }else{
        return ''
    }
}

export function changeURL(queryStrong) {
    let url = queryString.stringifyUrl({url: window.location.href, query: queryStrong});
    window.history.replaceState(null, "",url);
}

export const currencySymbol = 'تومان';

export const AddressesLimit = 5;

export function getComplexFileUrl(file,size = ''){
    if(!!file.thumbnail){
        return file.thumbnail
    }else if(!!file.src){
        return file.src
    }else{
        return  `${defaultVariabls.uploads}/FileManager/${file.name}${size}.${file.extension}`
    }
}

export const worked_statuses = ["در حد نو","قابل خواندن","دارای پارگی جلد","صفحاتی از کتاب موجود نیست","صفحاتی از کتاب دارای پارگی و خط خوردگی است"]